import { render } from "./DrawRainBowLightPage.vue?vue&type=template&id=5517eaaa"
import script from "./DrawRainBowLightPage.vue?vue&type=script&lang=js"
export * from "./DrawRainBowLightPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__